interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - current) <= 1) {
      pages.push(i);
    }
  }

  const btn = 'flex h-9 min-w-9 items-center justify-center rounded-md px-2 text-sm transition';

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${btn} border border-background-300/60 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-400 hover:enabled:text-foreground-950`}
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>

      {pages.map((page, idx) => {
        const prev = pages[idx - 1];
        const showEllipsis = prev && page - prev > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {showEllipsis && <span className="px-1 text-foreground-500">…</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`${btn} ${
                page === current
                  ? 'bg-primary-500 text-white'
                  : 'border border-background-300/60 text-foreground-700 hover:border-primary-400 hover:text-foreground-950'
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}

      <button
        type="button"
        disabled={current === totalPages}
        onClick={() => onChange(current + 1)}
        className={`${btn} border border-background-300/60 text-foreground-700 disabled:cursor-not-allowed disabled:opacity-40 hover:enabled:border-primary-400 hover:enabled:text-foreground-950`}
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}